import { GetEpicConnectUrl } from './types/types'
import { http } from '@/shared/http.ts'

export const getEpicRefresh = async (token: string) => {
  return await http.get('/epic/refresh', {
    token,
  })
}

export const getEgsConnect = async (token: string): Promise<GetEpicConnectUrl> => {
  return await http.get<GetEpicConnectUrl>('/epic/connect', {
    token,
  })
}



